import React, { Component, useState } from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";
import getTag from "../../services/getTag";
import deleteTag from "../../services/deleteTag";
import getCategorieTag from "../../services/getCategorieTag";

export default class Tag extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];

    this.selectRef = React.createRef();

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      selectPdfDatesVisible: false,
      fusioneEnabled: false,
      insegnanti: [],
      gruppiInsegnantiComplete: [],
      mailCompaniesList: [],
      reportPeriod: "",
      waitDialogFileVisible: false,
      fileReady: false,
      tag: [],
      optionsCategoria: [],
      selectedCategoria: null,
    };

    this.grid = 2;
    this.tableRef = React.createRef();

    this.pdfElements = [];

    this.pageTitle = "Tag";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({ list: [] });
    cookies.set("checksList", strJson, { path: "/" });
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.handleCategoriaChange = this.handleCategoriaChange.bind(this);

    this.state = {};
  }

  handleCategoriaChange(option) {
    if (option.value === "All") {
      this.setState({ selectedCategoria: null }, () => {
        this.reload();
      });
    } else {
      this.setState({ selectedCategoria: option }, () => {
        this.reload();
      });
    }
  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.tag = await getTag(username, token);
    this.categoriaTag = await getCategorieTag(username, token);

    const tagWithCategoria = this.tag
      .filter((tag) => {
        if (this.state.selectedCategoria) {
          return tag.id_categoria === this.state.selectedCategoria.value;
        }
        return true;
      })
      .map((tag) => {
        const categoria = this.categoriaTag.find(
          (categoria) => categoria.id === tag.id_categoria
        );
        return {
          id: tag.id,
          tag_name: tag.tag,
          categoria: categoria ? categoria.nome : "Categoria non trovata",
        };
      });

    this.setState({
      tag: tagWithCategoria,
      isLoading: false,
      optionsCategoria: [
        { value: "All", label: "Tutti" },
        ...this.categoriaTag.map((categoria) => ({
          value: categoria.id,
          label: categoria.nome,
        })),
      ],
    });
  }

  async componentDidMount() {
    await this.reload();
  }

  render() {
    var headCells = [
      //  { id: '__', numeric: false, disablePadding: true, label: '' },
      { id: "tag_name", numeric: false, disablePadding: true, label: "Tag" },
      {
        id: "categoria",
        numeric: false,
        disablePadding: true,
        label: "Categoria",
      },
      { id: "id", numeric: true, disablePadding: true, label: "ID" },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    this.searchCols = ["tag_name", "categoria"];

    const cookies = new Cookies();

    this.tableRef.current && this.tableRef.current.clearSearch();

    return (
      <div id={Math.random()}>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle
            title={this.pageTitle}
            button="NUOVO"
            onClick={() => {
              window.location.href = "/#/app/addTag";
            }}
            onSecondClick={() => {
              this.setState({
                fusioneEnabled: true,
              });
            }}
          />

          <Table
            searchValue={""}
            id={Math.random()}
            headCells={headCells}
            searchCols={this.searchCols}
            categorie={this.state.optionsCategoria}
            selectedCategoria={this.state.selectedCategoria}
            rows={this.state.tag}
            onChangeCategoria={this.handleCategoriaChange}
            onEventClick={(row) => {
              cookies.set("currentTag", row, { path: "/" });
              window.location.href = "/#/app/editTag";
            }}
            onDelete={async (id) => {
              if (
                window.confirm("Sei sicuro di voler eliminare il tag?") == false
              )
                return;

              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              await deleteTag(username, token, id);

              window.alert("Tag eliminato con successo");

              this.reload();
            }}
            onElementCheck={async (companyId) => {
              const cookies = new Cookies();

              var json = cookies.get("checksList", { path: "/" });
              var checksList = json.list;
              var index = checksList.indexOf(companyId);
              if (index != -1) checksList.splice(index, 1);
              else checksList.push(companyId);

              cookies.set("checksList", JSON.stringify({ list: checksList }), {
                path: "/",
              });
            }}
          />

          <WaitDialog
            show={this.state.waitDialogVisible}
            key={Math.random()}
            index={this.state.index}
          />
        </LoadingOverlay>
      </div>
    );
  }
}
